import { useFormContext } from 'react-hook-form';

import { StatusSelect } from '@/components/StatusSelect';
import { NamesByDrugStatusId } from '@/shared/constants/nomenclature-status.constants';
import type { RecordStatusId } from '@/shared/constants/record-status.constants';
import {
  getColorByRecordStatusId,
  RECORD_STATUS_ACTIVE,
  RECORD_STATUS_NEW,
} from '@/shared/constants/record-status.constants';

import type { NomenclatureFormProps } from '../modals/NomenclatureForm';
import { useDrugStatuses } from '../useDrugStatusList';

type NomenclatureStatusSelectProps = {
  drug: NomenclatureFormProps['drug'];
  onSelectStatus: (itemRecordStatusId: RecordStatusId) => void;
};

export const NomenclatureStatusSelect = (props: NomenclatureStatusSelectProps) => {
  const { drug, onSelectStatus } = props;
  const { watch } = useFormContext();

  const selectedRecordStatusId = watch('record_status_id') ?? RECORD_STATUS_ACTIVE;

  const { drugStatuses } = useDrugStatuses(drug?.id);
  const drugAvailableStatuses = drugStatuses?.record_status_ids ?? null;
  const statuses: RecordStatusId[] = drugAvailableStatuses ?? [RECORD_STATUS_NEW];

  return (
    <StatusSelect
      selectedRecordStatusId={selectedRecordStatusId}
      statuses={statuses}
      onSelectStatus={onSelectStatus}
      getLabelName={statusId => NamesByDrugStatusId[statusId]}
      getLabelColor={getColorByRecordStatusId}
    />
  );
};
